import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";
import SetContractOption from "../Contract/SetContractOption";
import UploadContract from "../Contract/UploadContract";
import AddContract from "../Contract/AddContract";

function AddNewOrder({ onClose }) {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const { setGlobalLoading, token } = useOutletContext();
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [data, setData] = useState([]);
  const [currency, setCurrencies] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [roleListData, setRoleListData] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [entities, setEntities] = useState([]);
  const companyId = watch("company_id");
  const roleId = watch("role_id");
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [contractShowModel, setContractShowModel] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedContractData, setSelectedContractData] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const feeValue = watch("fee_percentage");
  const [setContractOptionModel, setSetContractOptionModel] = useState(false);
  const [UploadModel, setUploadModel] = useState(false);
  const [Model, setModel] = useState(false);
  const [contractid, setcontractid] = useState(null);
  const [uploadContractData, setUploadContractData] = useState([]);
  const [newContractId, setNewContractId] = useState(false);

  useEffect(() => {
    const getCompanyDetails = async () => {
      try {
        //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/roles/company_list_details`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setData(response.data);
        setValue(
          "reference",
          response.data.next_reference?.[0]?.next_reference,
        );
        setCurrencies(response.data.currency || []);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getCompanyDetails();
  }, []);

  useEffect(() => {
    if (!companyId) {
      // Initial reset
      setRoleListData([]);
      setContracts([]);
      setSelectedContract(null);
      setSelectedContractData(null);
      setSelectedLevel(null);

      setValue("role_id", "");
      setValue("contract_id", "");
      setValue("companylevel_id", "");
      return;
    }

    // 🔥 RESET EVERYTHING WHEN COMPANY CHANGES
    setRoleListData([]);
    setContracts([]);
    setEntities([]);
    setRoleData([]);

    setSelectedContract(null);
    setSelectedContractData(null);
    setSelectedLevel(null);

    setValue("role_id", "");
    setValue("contract_id", "");
    setValue("companylevel_id", "");
    setValue("fee_percentage", "");
    setValue("total_fees", "");
    setValue("entity_id", "");
  }, [companyId]);

  useEffect(() => {
    if (!companyId) {
      setRoleListData([]);
      setValue("role_id", "");
      return;
    }
    setRolesLoading(true);
    const fetchRoles = async () => {
      try {
        //    setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/roles/role_list_by_company/${companyId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setRoleListData(response.data || []);
        setValue("role_id", "");
      } catch (error) {
        console.error(error);
      } finally {
        setGlobalLoading(false);
        setRolesLoading(false);
      }
    };

    fetchRoles();
  }, [companyId]);

  useEffect(() => {
    if (!companyId || !roleId) {
      setContracts([]);
      setSelectedContract(null);
      setSelectedContractData(null);
      setSelectedLevel(null);
      setValue("contract_id", "");
      return;
    }

    const fetchContracts = async () => {
      try {
        //    setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/role_detail/${roleId}/${companyId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        setRoleData(response.data.role_detail);
        setContracts(response.data.contract || []);
        setEntities(response.data.entities || []);
        setValue("fee_percentage", response.data.role_detail.fee_percentage);
        setValue(
          "reference",
          response.data.next_reference?.[0]?.next_reference,
        );
        setValue("user_id", response.data.role_detail.created_by);
      } catch (error) {
        console.error(error);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchContracts();
  }, [roleId]);

  const shouldShowInvoiceInfo =
    selectedContractData &&
    (selectedContractData.fee_type === "RoleWise" ||
      (selectedContractData.fee_type === "LevelWise" && selectedLevel));

  useEffect(() => {
    if (!selectedContractData || !roleData?.expected_compensation) return;

    if (selectedContractData.fee_type === "RoleWise") {
      const fee = selectedContractData.fee || 0;
      const expectedComp = roleData.expected_compensation;

      const totalFees = calculateTotalFees(expectedComp, fee);

      setValue("fee_percentage", fee, { shouldDirty: true });
      setValue("total_fees", totalFees, { shouldDirty: true });
    }

    if (selectedContractData.fee_type === "LevelWise") {
      setValue("fee_percentage", "");
      setValue("total_fees", "");
    }
  }, [selectedContractData, roleData]);

  const handleContractSelect = (contract) => {
    setSelectedContract(contract.id);
    setSelectedContractData(contract);
    setSelectedLevel(null);
    setValue("contract_id", contract.id);
    setValue("companylevel_id", null);

    const entityId = contract.entity_id;
    if (entityId === 3) {
      setValue("entity_id", 9);
    } else {
      setValue("entity_id", entityId);
    }
  };

  const calculateTotalFees = (expectedComp, fee) => {
    if (!expectedComp || !fee) return 0;
    let str = fee;
    const splits = str
      .split(",")
      .map((v) => v.replace("%", ""))
      .map((v) => Number(v))
      .filter((v) => v !== 0);
    const feeNumber = Number(splits);
    const compensation = Number(expectedComp);

    // percentage
    if (feeNumber < 100) {
      return Math.round((compensation * feeNumber) / 100);
    }

    // flat fee
    return Math.round(feeNumber);
  };

  const handleLevelSelect = (level) => {
    setSelectedLevel(level.id);
    setValue("companylevel_id", level.id);
    const fee = level.amount;
    const total = calculateTotalFees(roleData?.expected_compensation, fee);
    setValue("fee_percentage", fee);
    setValue("total_fees", total);
  };

  function format_currency(num) {
    const isFloat = !Number.isInteger(num);
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: isFloat ? 0 : 0, // show 2 decimals only if float
      maximumFractionDigits: isFloat ? 0 : 0,
    }).format(num);
  }

  const removeUploadedContract = async (id) => {
    try {
      const response = await axios.delete(
        `${REACT_APP_API_BASE_URL}/contracts/delete_contract_file/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 200) {
        navigate("/contract/list");
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/orders/add_order`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toastr.success("Order added successfully!");
      const invoiceId = response.data.invoice_id;
      onClose();
      navigate(`/order/view/${invoiceId}`);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
  const $selects = $(".order-searchable-select");

  $selects.each(function () {
    const $select = $(this);

    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }

    $select.select2({
      width: "100%",
      placeholder: "Select",
      allowClear: true,
      dropdownParent: $select.parent(),
    });

    // Important: keep React Hook Form in sync
    $select.off("change.orderSelect2");
    $select.on("change.orderSelect2", function () {
      const fieldName = $(this).attr("name");

      setValue(fieldName, $(this).val() || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
    });
  });

  return () => {
    $selects.each(function () {
      const $select = $(this);

      $select.off(".orderSelect2");

      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy");
      }
    });
  };
}, [data?.companies, roleListData]);

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md"
        role="document"
        style={{ maxWidth: "550px" }}
      >
        <div className="modal-content">
          {setContractOptionModel && (
            <SetContractOption
              onClose={(data) => {
                setSetContractOptionModel(false);
                data.model == "upload" && setUploadModel(true);
                data.model == "manually" && setModel(true);
              }}
            />
          )}
          {UploadModel && (
            <UploadContract
              onClose={(data) => {
                setUploadModel(false);
                setcontractid(data.contract_id);
                setUploadContractData(data.response);
                data.response != undefined && setModel(true);
              }}
            />
          )}
          {Model && (
            <AddContract
              onClose={(data) => {
                setModel(false);
                if (data != undefined) {
                  setSelectedContractId(data.contract_id);
                  setContractShowModel(true);
                  setNewContractId(true);
                } else {
                  if (contractid != null) {
                    removeUploadedContract(contractid);
                    setUploadContractData([]);
                    setcontractid(null);
                  }
                }
              }}
              updata={uploadContractData}
              contract_id={contractid}
            />
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add Order</h4>
              <button
                onClick={() => onClose()}
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="roleinfo">
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-2">
                      <label className="form-label">Client</label>
                      <select
                        className="form-select order-searchable-select"
                        {...register("company_id", { required: true })}
                      >
                        <option value=""></option>
                        {data?.companies?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-2">
                      <label className="form-label">Role</label>
                      <select
                        className="form-select order-searchable-select"
                        {...register("role_id", { required: true })}
                        disabled={!roleListData.length}
                      >
                        <option value="">Select Role</option>
                        {roleListData.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contractinfo">
                {!rolesLoading && companyId && roleListData.length === 0 && (
                  <p>
                    All roles for this client already have orders or no active
                    roles exist. <br />
                    Close this pop-up and search for the order to edit or add an
                    invoice.
                  </p>
                )}
                {contracts.length === 0 ? (
                  !roleId ? (
                    <p></p>
                  ) : (
                    <p>
                      There is no contract with this client, please add the
                      contract first.
                      <button
                        className="btn btn-sm btn-primary ms-auto"
                        title="Add Contract"
                        type="button"
                        onClick={() => {
                          setSetContractOptionModel(true);
                        }}
                      >
                        <i className="fa-solid fa-plus me-1"></i> Add Contract
                      </button>
                    </p>
                  )
                ) : (
                  <div class="table-responsive">
                    <table class="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "30px" }}></th>
                          <th style={{ width: "30px" }}></th>
                          <th className="fs-10">AGN No</th>
                          <th className="fs-10">Status</th>
                          <th className="fs-10">Signed</th>
                          <th className="fs-10">Entity</th>
                          <th className="fs-10">Comment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contracts.map((contract) => (
                          <tr key={contract.id}>
                            <td style={{ width: "30px" }}>
                              <input
                                type="radio"
                                name="contract"
                                value={contract.id}
                                checked={selectedContract === contract.id}
                                onChange={() => handleContractSelect(contract)}
                              />
                            </td>
                            <td style={{ width: "30px" }}>
                              <i
                                className="ti ti-eye"
                                title={`Fee: ${contract.fee || "-"}`}
                              ></i>
                            </td>
                            <td className="fs-10">{contract.agn}</td>
                            <td className="fs-10">{contract.status}</td>
                            <td className="fs-10">
                              {contract.contractSigned === 1 ? "Yes" : "No"}
                            </td>
                            <td className="fs-10">
                              {contract.entity_name || "Global"}
                            </td>
                            <td className="fs-10">
                              {contract.comments || "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {selectedContractData?.fee_type === "LevelWise" && (
                  <div className="col-md-12 mt-2">
                    <label className="form-label">Select Level</label>
                    <div className="table-responsive">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "30px" }}></th>
                            <th className="fs-10">Level Name</th>
                            <th className="fs-10">Amount</th>
                            <th className="fs-10">Cap Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          {selectedContractData?.levels?.length > 0 ? (
                            selectedContractData.levels.map((level) => (
                              <tr key={level.id}>
                                <td style={{ width: "30px" }}>
                                  <input
                                    type="radio"
                                    name="level"
                                    checked={selectedLevel === level.id}
                                    onChange={() => handleLevelSelect(level)}
                                  />
                                </td>

                                <td className="fs-10">{level.name}</td>

                                <td className="fs-10">
                                  {level.amount}
                                  {level.amount < 100 ? "%" : ""}
                                </td>

                                <td className="fs-10">
                                  {level.capAmount ? level.capAmount : "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center fs-10 text-muted"
                              >
                                No levels available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              {shouldShowInvoiceInfo && (
                <div className="invoiceinfo">
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="mb-2">
                        <label className="form-label">Reference ID</label>
                        {/* <input type="hidden" {...register("company_id")} />
                                <input type="hidden" {...register("role_id")} /> */}
                        <input type="hidden" {...register("user_id")} />
                        <input type="hidden" {...register("contract_id")} />
                        <input type="hidden" {...register("companylevel_id")} />
                        <input
                          type="text"
                          {...register("reference")}
                          className={`form-control ${errors.reference && "is-invalid"}`}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">Client</label>
                        <input
                          type="text"
                          className={`form-control ${errors.company && "is-invalid"}`}
                          value={roleData.company}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">Role</label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_name && "is-invalid"}`}
                          value={roleData.role_name}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">
                          Fee Percentage / Flat Fee *
                        </label>
                        <input
                          type="text"
                          {...register("fee_percentage", {
                            required: "required",
                          })}
                          className={`form-control ${errors.fee_percentage && "is-invalid"}`}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">
                          Raised Location Entity*
                        </label>
                        {/* <input type="text" {...register("rased_location", { required: "required" })} className={`form-control ${ errors.rased_location && "is-invalid"}`} /> */}
                        <select
                          {...register("entity_id", {
                            required: "Please select entity",
                          })}
                          className={`form-select ${
                            errors.entity_id && "is-invalid"
                          }`}
                        >
                          <option value="">Select</option>
                          {entities.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <div className="mb-2">
                        <label className="form-label">
                          Expected Compensation: {roleData?.symbol}{" "}
                          {format_currency(roleData?.expected_compensation)} (
                          {roleData?.currency_name})
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">Total Fees *</label>
                        <input
                          type="text"
                          {...register("total_fees", { required: "required" })}
                          className={`form-control ${errors.total_fees && "is-invalid"}`}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3">
                      <div className="mb-2">
                        <label className="form-label"> &nbsp; </label>
                        <select
                          {...register("currency_id", {
                            required: true,
                          })}
                          className="form-select"
                        >
                          {currency.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.symbol} - {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3">
                      <div className="mb-2">
                        <label className="form-label">Purchase Order *</label>
                        <select
                          {...register("purchase_order")}
                          className="form-select"
                        >
                          <option value="no">No</option>
                          <option value="yes">Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              {shouldShowInvoiceInfo && (
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              )}
              <button
                onClick={onClose}
                type="button"
                className="btn btn-secondary ms-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default AddNewOrder;
